import { canAccessTherapistFinanceNav } from "@/domains/multi/clinicMemberPaths";
import { useAuth } from "@/domains/shared/hooks/useAuth";
import { Roles } from "@/domains/shared/models/roles";
import { Navigate, Outlet } from "react-router";

/** Blocks Financeiro desk for clinic members who are not Administrador or Financeiro. */
export default function TherapistFinanceRouteGuard() {
    const { user } = useAuth();

    if (user?.role !== Roles.Therapist) {
        return <Outlet />;
    }

    if (!canAccessTherapistFinanceNav(user)) {
        return <Navigate to="/profissional" replace />;
    }

    return <Outlet />;
}
